document.addEventListener('DOMContentLoaded', function () {
  var section = document.getElementById('fc-rp-section');
  var popup = document.getElementById('fc-rp-popup');
  var textEl = document.getElementById('fc-rp-text');
  var timeEl = document.getElementById('fc-rp-time');
  var closeBtn = document.getElementById('fc-rp-close');
  var productsScript = document.getElementById('fc-rp-products');

  if (!section || !popup || !productsScript) return;

  var products = [];
  try {
    products = JSON.parse(productsScript.textContent);
  } catch (e) {
    products = [];
  }

  if (!products.length) return;

  /*
    PENTRU ADĂUGAT ȚĂRI/NUME/ORAȘE NOI:
    adaugă un obiect nou în array-ul de mai jos, cu structura:
    { country: 'Nume Țară', names: ['Nume1', 'Nume2', ...], cities: ['Oraș1', 'Oraș2', ...] }
  */
  var countryData = [
    {
      country: 'Romania',
      names: ['Andrei', 'Maria', 'Ionuț', 'Bogdan', 'Elena', 'Cristian', 'Ioana', 'Radu', 'Ștefan', 'Vlad','Sebastian', 'Mario','Patrick'],
      cities: ['București', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța', 'Brașov','Lugoj','Arad']
    },
    {
      country: 'Spain',
      names: ['Javier', 'Carlos', 'Lucía', 'Marta', 'Sergio', 'Elena', 'Pablo', 'Ana', 'Mohammed', 'Isabel', 'Diego', 'Sofía'],
      cities: ['Madrid', 'Barcelona', 'Valencia', 'Sevilla']
    },
    {
      country: 'Italy',
      names: ['Marco', 'Giulia', 'Luca', 'Francesca', 'Matteo', 'Sara', 'Alessandro', 'Chiara'],
      cities: ['Milano', 'Roma', 'Torino', 'Napoli']
    },
    {
      country: 'England',
      names: ['James', 'Emma', 'Oliver', 'Charlotte', 'Harry', 'Sophie', 'Jack', 'Amelia'],
      cities: ['London', 'Manchester', 'Liverpool', 'Birmingham']
    },
    {
      country: 'France',
      names: ['Lucas', 'Léa', 'Hugo', 'Camille', 'Nathan', 'Manon', 'Arthur', 'Chloé'],
      cities: ['Paris', 'Lyon', 'Marseille', 'Toulouse']
    },
    {
      country: 'Brazil',
      names: ['Gabriel', 'Beatriz', 'Lucas', 'Larissa', 'Rafael', 'Julia', 'Felipe', 'Camila'],
      cities: ['São Paulo', 'Rio de Janeiro', 'Belo Horizonte']
    },
    {
      country: 'Germany',
      names: ['Lukas', 'Anna', 'Felix', 'Laura', 'Jonas', 'Lena', 'Michael', 'Emily'],
      cities: ['Berlin', 'München', 'Hamburg', 'Köln']
    },
    {
      country: 'United States',
      names: ['Lukas', 'Anna', 'Felix', 'Laura', 'Jonas', 'Lena', 'Michael', 'Emily', 'Joshua', 'Madison', 'Daniel', 'Olivia','Rodriguez'],
      cities: ['New York', 'Los Angeles', 'Chicago', 'Houston']
    }
  ];

  var timePool = [
    'just now', '1 minute ago', '2 minutes ago', '4 minutes ago', '6 minutes ago',
    '9 minutes ago', '12 minutes ago', '18 minutes ago', '24 minutes ago', '31 minutes ago'
  ];

  var displayDuration = parseInt(section.dataset.displayDuration, 10) || 6;
  var intervalBetween = parseInt(section.dataset.intervalBetween, 10) || 15;
  var initialDelay = parseInt(section.dataset.initialDelay, 10) || 4;

  var dismissedBySession = sessionStorage.getItem('fc_rp_dismissed');
  if (dismissedBySession === '1') return;

  var hideTimer = null;
  var cycleTimer = null;

  function pickRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function showNext() {
    var country = pickRandom(countryData);
    var name = pickRandom(country.names);
    var city = pickRandom(country.cities);
    var product = pickRandom(products);
    var time = pickRandom(timePool);

    textEl.innerHTML = '<strong>' + name + '</strong> from ' + city + ' just bought <strong>' + product + '</strong>';
    timeEl.textContent = time;

    popup.classList.add('fc-rp-visible');

    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      popup.classList.remove('fc-rp-visible');
    }, displayDuration * 1000);
  }

  function scheduleNext(delaySeconds) {
    clearTimeout(cycleTimer);
    cycleTimer = setTimeout(function () {
      showNext();
      scheduleNext(intervalBetween);
    }, delaySeconds * 1000);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      popup.classList.remove('fc-rp-visible');
      clearTimeout(hideTimer);
      clearTimeout(cycleTimer);
      sessionStorage.setItem('fc_rp_dismissed', '1');
    });
  }

  scheduleNext(initialDelay);
});